import { BusinessContextModel } from '../../../core/model/BusinessContext.model';
import { SlaMonitoredServicesHttpQuery } from './SlaMonitoredServicesQuery.config';

export const SlaStatisticsBusinessContextConfig: BusinessContextModel = {
  queries: SlaMonitoredServicesHttpQuery,
  translateNamespace: 'slaStatistics'
}
